<template>
    <div class="container">
        <back-to-last-trajectory />
        <div class="row">
            <div class="col-12">
                <div class="panel">
                    <div class="panel__header">
                        <h2>
                            <i class="panel__header__icon icons icon-docs"></i>
                            <span>{{$t('survey_templates.title')}}</span>
                        </h2>
                        <div @click.prevent="addNew" class="panel_header__action">
                            <i class="panel_header__action__icon icons icon-plus"></i>
                            <a class="button--link">{{$t('survey_templates.add_new')}}</a>
                        </div>
                    </div>
                    <div class="panel__body">
                        <survey-templates-table />
                    </div>
                    <survey-template-modal />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue';
    import Component from 'vue-class-component';
    import SurveyTemplatesTable from '@/components/tables/survey-templates/SurveyTemplatesTable';
    import SurveyTemplateModal from '@/components/modals/survey-templates/SurveyTemplateModal';
    import BackToLastTrajectory from '@/components/general/BackToLastTrajectory';


    import SurveyTemplate from '@/models/SurveyTemplate';

    @Component({
        components: {
            SurveyTemplatesTable,
            SurveyTemplateModal,
            BackToLastTrajectory,
        }
    })
    export default class SurveyTemplates extends Vue {
        name = 'survey-templates';

        addNew() {
            const template = new SurveyTemplate();
            this.$modal.show('survey-template-modal', { template });
        }
    }
</script>



// WEBPACK FOOTER //
// src/pages/SurveyTemplates.vue